// extracted by mini-css-extract-plugin
export default {"total-item":"OhTaxes_total-item__3SCM8"};